import React from 'react';

function ProcoreHexIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.70073 0L0 8.03376L4.70073 16H13.9659L18.6667 8.03376L13.9659 0H4.70073Z"
        fill="#FF5200"
      />
    </svg>
  );
}

export default ProcoreHexIcon;
